import { Field } from "formik";
import React from "react";
import { Form, FormText } from "react-bootstrap";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const FormikDateField = ({
  md,
  controlId,
  label,
  name,
  className,
  showTime,
  timezone,
  dateFormat,
}) => {
  return (
    <Field
      name={name}
      render={({ field, form }) => {
        const isValid = !form.errors[field.name];
        const isInvalid = form.touched[field.name] && !isValid;
        return (
          <Form.Group
            md={md}
            controlId={controlId}
            className={`form-group ${className}`}
          >
            <Form.Label>{label}</Form.Label>
            <Datetime
              size="lg"
              locale={timezone}
              label={label}
              isInvalid={isInvalid}
              timeFormat={false}
              value={field.value}
              closeOnSelect={true}
              inputProps={{
                placeholder: label,
                disabled: false,
                readOnly: true,
              }}
              onChange={(selectedDate) => {
                form.setFieldTouched(field.name, true);
                let inputDate = selectedDate;
                if (dateFormat) {
                  inputDate = selectedDate.utc().format(dateFormat);
                }
                form.setFieldValue(controlId, inputDate);
              }}
            />
            {field.name in form.errors &&
              form.errors[field.name] &&
              form.touched &&
              field.name in form.touched &&
              form.touched[field.name] && (
                <FormText className="dobError">
                  {form.errors[field.name]}
                </FormText>
              )}
          </Form.Group>
        );
      }}
    />
  );
};

export default FormikDateField;
